<template>
  <div class="loader">
    <div class="product">
      <div class="product-gallery">
        <div class="product-gallery-preview">
          <GFMP />
        </div>
        <div class="product-gallery-thumb">
          <GFMP v-for="i in 5" :key="i" />
        </div>
        <div class="product-share">
          <GFMP v-for="i in 5" :key="i" />
        </div>
      </div>
      <div class="product-body">
        <div class="brand-title">
          <GFMP />
        </div>
        <div class="product-title">
          <GFMP />
        </div>
        <div class="available-store">
          <GFMP v-for="i in 3" :key="i" />
        </div>
        <div class="product-size">
          <GFMP />
        </div>
        <div class="product-summary">
          <div class="product-summary-1">
            <div class="title">
              <GFMP />
            </div>
            <div class="rating">
              <GFMP v-for="i in 5" :key="i" />
            </div>
            <div class="text">
              <GFMP v-for="i in 3" :key="i" />
            </div>
          </div>
          <div class="product-summary-2">
            <div class="product-title">
              <GFMP />
            </div>
            <div v-for="row in 2" :key="row" class="rating-row">
              <div v-for="col in 2" :key="col" class="rating-col">
                <GFMP v-for="i in 2" :key="i" />
              </div>
            </div>
          </div>
        </div>
        <div class="product-repurchase">
          <div class="title">
            <GFMP />
          </div>
          <div class="average-rating">
            <div v-for="i in 2" :key="i" class="review-repurchase">
              <GFMP v-for="_i in 2" :key="_i" />
            </div>
          </div>
        </div>
        <div class="expert-review">
          <div class="profile">
            <div class="profile-avatar">
              <GFMP />
            </div>
            <div class="profile-info">
              <GFMP v-for="i in 2" :key="i" />
            </div>
          </div>
          <div class="expert-review-details">
            <GFMP />
          </div>
        </div>
        <div class="product-review">
          <div class="product-review-title">
            <GFMP />
          </div>
          <div class="product-review-gallery">
            <GFMP v-for="i in 8" :key="i" />
          </div>
        </div>
        <div class="product-action">
          <GFMP v-for="i in 3" :key="i" />
        </div>
        <div class="product-tab">
          <div class="product-tab-nav">
            <GFMP v-for="i in 3" :key="i" />
          </div>
          <div class="product-tab-content">
            <GFMP v-for="i in 8" :key="i" />
          </div>
        </div>
        <div class="product-about">
          <div class="product-about-header">
            <GFMP v-for="i in 2" :key="i" />
          </div>
          <div class="product-about-body">
            <div class="product-image">
              <GFMP />
            </div>
            <div class="product-detail">
              <GFMP v-for="i in 3" :key="i" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relevant-review">
      <div class="relevant-review-title">
        <GFMP />
      </div>
      <div class="relevant-review-subtitle">
        <GFMP />
      </div>
      <div class="relevant-review-carousel">
        <div v-for="card in 2" :key="card" class="relevant-review-card">
          <div class="card-header">
            <div class="review-rating">
              <GFMP v-for="i in 5" :key="i" />
            </div>
            <div class="review-user-name">
              <GFMP />
            </div>
          </div>
          <div class="card-body">
            <div class="review-detail">
              <GFMP v-for="i in 5" :key="i" />
            </div>
            <div class="review-image">
              <GFMP v-for="i in 2" :key="i" />
            </div>
          </div>
          <div class="card-footer">
            <div class="review-action">
              <GFMP v-for="i in 4" :key="i" />
            </div>
            <div class="review-report">
              <GFMP />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-review">
      <div class="review">
        <div class="review-filter">
          <div class="review-filter-tab">
            <GFMP v-for="i in 4" :key="i" />
          </div>
          <div class="review-filter-selection">
            <GFMP v-for="i in 4" :key="i" />
          </div>
        </div>
        <div class="review-personalized">
          <div class="review-personalized-title">
            <GFMP />
          </div>
          <div class="skin-list">
            <div v-for="skin in 5" :key="skin" class="skin-item">
              <GFMP v-for="i in 2" :key="i" />
            </div>
          </div>
        </div>
        <div class="review-list">
          <ReviewCardListLoader />
        </div>
      </div>
      <ProductInlineListLoader :list-count="10" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-detail-loader',
  components: {
    ReviewCardListLoader: () => import('@/components/global/loader/review-card-list-loader'),
    ProductInlineListLoader: () => import('@/components/global/loader/product-inline-list-loader'),
  },
};
</script>

<style lang="scss" scoped>
$defaultSpacing: 8px;
$defaultGrey: #f6f6f6;
$defaultDarkGrey: #e6e6e6;

@mixin fmpCircle {
  :first-child {
    border-radius: 50%;
    height: 20px;
  }
}

@mixin fmpRounded {
  :first-child {
    border-radius: 8px;
  }
}

@mixin fmpTextLarge {
  :first-child {
    height: 20px;
  }
}

@mixin fmpTextMedium {
  :first-child {
    height: 16px;
  }
}

@mixin fmpTextSmall {
  :first-child {
    height: 12px;
  }
}

@mixin flexColumn {
  display: flex;
  flex-direction: column;
}

@function getRandomWidth($min: 30, $max: 100) {
  @return percentage(($min + (random() * ($max - $min))) / 100);
}
.loader {
  @include flexColumn();
  gap: 24px;

  .FMP_WRAPPER {
    @include fmpRounded();
    :first-child {
      line-height: 0;
      min-height: 16px;
    }
  }

  .product {
    display: flex;
    gap: 32px;
    width: 100%;
    padding: 32px;
    background-color: white;
    border-radius: 8px;

    &-gallery {
      @include flexColumn();
      gap: 16px;
      width: 35%;

      &-preview .FMP_WRAPPER :first-child {
        aspect-ratio: 1/1;
      }

      &-thumb {
        display: flex;
        gap: 16px;

        .FMP_WRAPPER {
          width: calc(100% / 5);
          :first-child {
            aspect-ratio: 1/1;
          }
        }
      }

      .product-share {
        display: flex;
        gap: $defaultSpacing;

        .FMP_WRAPPER {
          width: 24px;
          :first-child {
            aspect-ratio: 1/1;
          }
        }
      }
    }

    &-body {
      @include flexColumn();
      gap: 16px;
      width: 65%;

      .brand-title .FMP_WRAPPER {
        @include fmpTextMedium();
        width: 70%;
      }

      .product {
        &-title .FMP_WRAPPER {
          @include fmpTextLarge();
          width: 60%;
        }

        &-size {
          @include fmpTextMedium();
          width: 55%;
        }

        &-summary {
          display: flex;
          gap: 16px;
          padding-top: 16px;

          &-1 {
            @include flexColumn();
            gap: 16px;
            flex-grow: 1;
            width: 100%;

            .rating {
              display: flex;
              gap: $defaultSpacing;

              .FMP_WRAPPER {
                @include fmpCircle();

                :first-child {
                  width: 32px;
                  height: 32px;
                }
              }
            }

            .text {
              @include flexColumn();
              gap: $defaultSpacing;

              .FMP_WRAPPER {
                @include fmpTextSmall();
              }

              :nth-child(1).FMP_WRAPPER,
              :nth-child(2).FMP_WRAPPER {
                width: 80%;
              }

              :nth-child(3).FMP_WRAPPER {
                width: 95%;
              }
            }
          }

          &-2 {
            @include flexColumn();
            gap: 16px;
            flex-grow: 1;
            width: 100%;

            .rating {
              &-row {
                display: flex;
                gap: 16px;
              }

              &-col {
                display: flex;
                gap: $defaultSpacing;
                flex-grow: 1;
                width: 100%;

                :first-child.FMP_WRAPPER {
                  width: 32px;
                }

                :last-child.FMP_WRAPPER {
                  flex-grow: 1;
                }
              }
            }
          }

          .title .FMP_WRAPPER {
            @include fmpTextSmall();
            width: 10%;
          }
        }

        &-repurchase {
          @include flexColumn();
          gap: 16px;

          .title {
            @include fmpTextSmall();
            width: 80%;
          }

          .average-rating {
            display: flex;
            background-color: $defaultGrey;
            padding: 16px 0;

            .review-repurchase {
              display: flex;
              justify-content: center;
              gap: $defaultSpacing;
              flex-grow: 1;
              align-items: center;

              :first-child.FMP_WRAPPER {
                @include fmpCircle();
              }

              :last-child.FMP_WRAPPER {
                @include fmpTextSmall();
                width: 30%;
              }
            }
          }
        }

        &-review {
          @include flexColumn();
          gap: 24px;

          &-title .FMP_WRAPPER {
            @include fmpTextSmall();
            width: 80%;
          }

          &-gallery {
            display: flex;
            gap: $defaultSpacing;

            .FMP_WRAPPER {
              flex-grow: 1;
              width: 100%;

              :first-child {
                aspect-ratio: 1/1;
              }
            }
          }
        }

        &-action {
          display: flex;
          gap: 16px;
          width: 80%;

          :nth-child(1).FMP_WRAPPER,
          :nth-child(2).FMP_WRAPPER {
            flex-grow: 1;

            :first-child {
              height: 40px;
            }
          }

          :last-child.FMP_WRAPPER :first-child {
            width: 38px;
            aspect-ratio: 1/1;
          }
        }

        &-tab {
          @include flexColumn();
          gap: 24px;

          .FMP_WRAPPER {
            @include fmpTextSmall();
          }

          &-nav {
            display: flex;
            gap: 32px;
            padding: 16px 24px;
            border-bottom: 1px solid $defaultGrey;

            .FMP_WRAPPER {
              width: 48px;
            }
          }

          &-content {
            @include flexColumn();
            gap: 4px;

            @for $i from 1 through 8 {
              :nth-child(#{$i}).FMP_WRAPPER :first-child {
                width: getRandomWidth(50, 95);
              }
            }
          }
        }

        &-about {
          @include flexColumn();
          gap: 16px;
          padding: 16px;

          &-header {
            display: flex;
            justify-content: space-between;

            .FMP_WRAPPER {
              width: 15%;
            }
          }

          &-body {
            display: flex;
            gap: 16px;

            .product {
              &-image .FMP_WRAPPER :first-child {
                width: 72px;
                aspect-ratio: 1/1;
              }

              &-detail {
                @include flexColumn();
                flex-grow: 1;
                gap: 4px;

                @for $i from 1 to 3 {
                  :nth-child(#{$i}).FMP_WRAPPER {
                    @include fmpTextSmall();
                    width: getRandomWidth(60, 95);
                  }
                }
              }
            }
          }
        }
      }

      .available-store {
        display: flex;
        gap: $defaultSpacing;
        align-items: center;
        padding: 16px 0;

        :first-child.FMP_WRAPPER {
          @include fmpCircle();
        }

        :nth-child(2).FMP_WRAPPER {
          @include fmpTextMedium();
          width: 20%;
        }

        :nth-child(3).FMP_WRAPPER {
          @include fmpTextMedium();
          width: 10%;
        }
      }

      .expert-review {
        @include flexColumn();
        gap: 16px;
        padding: 16px;
        background-color: $defaultGrey;

        .profile {
          display: flex;
          gap: $defaultSpacing;
          align-items: center;

          &-avatar .FMP_WRAPPER {
            :first-child {
              width: 32px;
              aspect-ratio: 1/1;
            }
          }

          &-info {
            @include flexColumn();
            gap: 4px;
            flex-grow: 1;

            .FMP_WRAPPER {
              @include fmpTextSmall();
            }

            :first-child.FMP_WRAPPER {
              width: 30%;
            }

            :last-child.FMP_WRAPPER {
              width: 60%;
            }
          }
        }

        &-details {
          .FMP_WRAPPER {
            @include fmpTextSmall();
            width: 45%;
          }
        }
      }
    }
  }
  .relevant-review {
    @include flexColumn();
    gap: 16px;

    .FMP_WRAPPER {
      @include fmpTextSmall();
    }

    &-title {
      width: 15%;
    }

    &-subtitle {
      width: 50%;
    }

    &-carousel {
      display: flex;
      gap: 16px;

      .relevant-review-card {
        @include flexColumn();
        gap: 16px;
        padding: 16px;
        flex-grow: 1;
        background-color: white;
        border-radius: $defaultSpacing;
        margin-top: 16px;

        .card {
          &-header {
            display: flex;
            justify-content: space-between;

            .review {
              &-rating {
                display: flex;
                gap: 4px;

                .FMP_WRAPPER {
                  @include fmpCircle();
                }
              }

              &-user-name {
                width: 15%;
              }
            }
          }

          &-body {
            display: flex;
            gap: 24px;
            .review {
              &-detail {
                @include flexColumn();
                gap: $defaultSpacing;
                flex-grow: 1;

                @for $i from 1 to 5 {
                  :nth-child(#{$i}).FMP_WRAPPER {
                    width: getRandomWidth(40, 100);
                  }
                }
              }

              &-image {
                display: flex;
                gap: $defaultSpacing;

                .FMP_WRAPPER :first-child {
                  width: 64px;
                  height: 64px;
                }
              }
            }
          }

          &-footer {
            display: flex;
            justify-content: space-between;

            .review {
              &-action {
                display: flex;
                gap: $defaultSpacing;
                align-items: center;

                :nth-child(odd).FMP_WRAPPER {
                  @include fmpCircle();
                }

                :nth-child(even).FMP_WRAPPER {
                  width: 48px;
                }
              }

              &-report .FMP_WRAPPER {
                @include fmpCircle();

                :first-child {
                  width: 24px;
                  height: 24px;
                }
              }
            }
          }
        }
      }
    }
  }

  .product-review {
    display: flex;
    gap: 32px;

    .review {
      @include flexColumn();
      gap: 24px;
      flex-grow: 1;
      width: 100%;

      &-filter {
        background-color: white;
        padding: 0 24px;

        &-tab {
          display: flex;
          gap: 32px;
          padding: 16px 0;
          border-bottom: 1px solid $defaultGrey;

          .FMP_WRAPPER {
            @include fmpTextMedium();
            width: 48px;
          }
        }

        &-selection {
          display: flex;
          gap: 32px;
          padding: 32px 0;

          .FMP_WRAPPER {
            @include fmpTextSmall();
            width: 88px;
          }
        }
      }

      &-personalized {
        @include flexColumn();
        gap: 24px;

        &-title .FMP_WRAPPER {
          @include fmpTextSmall();
          width: 30%;
        }

        .skin {
          &-list {
            display: flex;
            gap: 48px;
          }

          &-item {
            display: flex;
            gap: $defaultSpacing;
            align-items: center;

            :first-child.FMP_WRAPPER {
              @include fmpCircle();
            }

            :last-child.FMP_WRAPPER {
              @include fmpTextSmall();
              width: 48px;
            }
          }
        }
      }

      &-list {
        padding: 24px;
        background-color: white;
      }
    }
  }
}
</style>
